import { BaseDto } from './base.dto';
import { SaleMediumTypeEnum } from './SaleMediumType.enum';

export class SaleMediumDto extends BaseDto {
    name: string;
    saleMediumType?: SaleMediumTypeEnum;
}